import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../response.js';
import { acceptJson } from '../shared.js';
import { getConfigResponse } from './specs.js';

const getConfig = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, { scope  }, init) {
        return validateResponse(getConfigResponse, (yield fetch(`${apiUrl}/upload/config/${scope}`, swcHelpers.objectSpread({
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        }, init))));
    });
    return function getConfig(apiUrl, _, init) {
        return _ref.apply(this, arguments);
    };
}();

export { getConfig };
//# sourceMappingURL=get-config.js.map
